import React, { useState } from "react";
import "./Testimonials.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      icon: (
        <i
          className="fas fa-quote-left"
          style={{ fontSize: "24px", color: "#333" }}
        />
      ),
      quote:
        "Who can receive the hypnosis and shame of a yogi if he has the fraternal afterlife of the sun.",

      name: "Larry Page",
      title: "Founder at Google",
      image: "/assets/images/Testimonials/Layer-1.png",
    },
    {
      id: 2,
      icon: (
        <i
          className="fas fa-quote-left"
          style={{ fontSize: "24px", color: "#333" }}
        />
      ),
      quote:
        "Who can receive the hypnosis and shame of a yogi if he has the fraternal afterlife of the sun.",
      name: "Larry Page",
      title: "Founder at Google",
      image: "/assets/images/Testimonials/Layer-2.png",
    },
    {
      id: 3,
      icon: (
        <i
          className="fas fa-quote-left"
          style={{ fontSize: "24px", color: "#333" }}
        />
      ),
      quote:
        "Who can receive the hypnosis and shame of a yogi if he has the fraternal afterlife of the sun.",
      name: "Larry Page",
      title: "Founder at Google",
      image: "/assets/images/Testimonials/Layer-2.png",
    },
    // {
    //   id: 4,
    //   icon: (
    //     <i
    //       className="bi bi-arrow-left-circle"
    //       style={{ fontSize: "24px", color: "#999" }}
    //     />
    //   ),
    //   quote:
    //     "Who can receive the hypnosis and shame of a yogi if he has the fraternal afterlife of the sun.",
    //   name: "Satya Nadella",
    //   title: "CEO at Microsoft",
    //   image: "/assets/images/Testimonials/Layer-4.png",
    // },
    // {
    //   id: 5,
    //   icon: (
    //     <i
    //       className="fas fa-quote-left"
    //       style={{ fontSize: "24px", color: "#333" }}
    //     />
    //   ),
    //   quote:
    //     "Who can receive the hypnosis and shame of a yogi if he has the fraternal afterlife of the sun.",
    //   name: "Tim Cook",
    //   title: "CEO at Apple",
    //   image: "/assets/images/Testimonials/Layer-5.png",
    // },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const length = testimonials.length;

  const scrollLeft = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + length) % length);
  };

  const scrollRight = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % length);
  };

  const getVisibleItems = () => {
    const prev = (currentIndex - 1 + length) % length;
    const next = (currentIndex + 1) % length;
    return [
      testimonials[prev], // Left card
      testimonials[currentIndex], // Active card
      testimonials[next], // Right card
    ];
  };

  const visibleItems = getVisibleItems();

  return (
    <div className="testimonials-container Onlybottom-border">
      <div className="testimonials">
        <h2>The Knowledge Hub</h2>
        <h1>Hear From 5,000+ Satisfied Clients</h1>
        <p>
          Discover how we’ve helped businesses simplify valuation, make better
          decisions, and unlock growth opportunities.
        </p>
        <div className="carousel">
          <button className="carousel-button prev" onClick={scrollLeft}>
            <i class="fa-solid fa-chevron-left" style={{ color: "black" }}></i>
          </button>
          <div className="carousel-items">
            {visibleItems.map((testimonial, index) => (
              <div
                className={`testimonial-card ${
                  index === 1 ? "active" : "near"
                }`}
                key={testimonial.id}
              >
                <h3 className="dot">{testimonial.icon}</h3>
                <div className="quote-icon"></div>
                <img
                  className="testimonial-image"
                  src={testimonial.image}
                  alt={testimonial.name}
                />
                <h3 className="testimonial-quote">{testimonial.quote}</h3>
                <h4 className="testimonial-name">{testimonial.name}</h4>
                <h3 className="testimonial-title">{testimonial.title}</h3>
              </div>
            ))}
          </div>
          <button className="carousel-button next" onClick={scrollRight}>
            <i class="fa-solid fa-chevron-right" style={{ color: "black" }}></i>{" "}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
